import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
var _hoisted_1 = {
    key: 0,
    class: "text-12px"
};
var _hoisted_2 = /*#__PURE__*/ _createElementVNode("a", {
    href: "https://engate.jp/mypage/settings/",
    class: "px-6 flex items-center",
    target: "_blank",
    rel: "noopener"
}, [
    /*#__PURE__*/ _createElementVNode("i", { class: "icon-settings mr-4 text-24px" }),
    /*#__PURE__*/ _createTextVNode("設定 ")
], -1);
var _hoisted_3 = [
    _hoisted_2
];
import { computed } from 'vue';
import { useAuthStore } from '../../store';
export default /*#__PURE__*/ _defineComponent({
    __name: 'MenuItemSettings',
    props: {},
    emits: [
        'onDoAction',
    ],
    setup: function (__props, _a) {
        var emit = _a.emit;
        var props = __props;
        var authStore = useAuthStore();
        var onDoAction = function () {
            emit('onDoAction');
        };
        var isAuth = computed(function () {
            return authStore.isAuth;
        });
        return function (_ctx, _cache) {
            return (isAuth.value)
                ? (_openBlock(), _createElementBlock("li", _hoisted_1, _hoisted_3))
                : _createCommentVNode("", true);
        };
    }
});
